const appetizers = [
  {
    title: 'Shrimp Cocktail',
    price: '$9.99',
    tags: 'Five Large Shrimp in a chilled glass with Cocktail Sauce and Lemon',
  },
  {
    title: 'Potato Skins',
    price: '$7.49',
    tags: 'Covered in Bacon, Cheddar-Jack Cheese, Green Onions, Served with Ranch',
  },
  {
    title: 'Fried Mushrooms',
    price: '$8.99',
    tags: 'Breaded Mushrooms Served with Homemade Ranch',
  },
  {
    title: 'Crab Cakes',
    price: '$9.49',
    tags: 'Our Own Recipe, With Homemade Tartar Sauce',
  },
  {
    title: 'Fried Cheese Curds',
    price: '$8.99',
    tags: 'Garlic Breaded Cheddar Cheese Curds serve with Marinara',
  },
  {
    title: 'Texas Toothpicks',
    price: '$8.99',
    tags: 'Fired Onions and Jalapeno Strips Served With Ranch Dressing',
  },
  {
    title: 'Spinach & Artichoke Dip',
    price: '$8.49',
    tags: 'A rich Start to Your Meal, Served with Toasted Bread Points',
  },
  {
    title: 'Chicken Strips',
    price: '$8.49',
    tags: 'Hand Breaded Chicken Tenders Served With Choice of Dipping Sauce',
  },
  {
    title: 'Boneless Chicken Bites',
    price: '$8.99',
    tags: 'Tossed in Buffalo or BBQ Sauce',
  },
  {
    title: 'Fried Green Beans',
    price: '$7.99',
    tags: 'Served With Homemade Chipotle Ranch',
  },
  {
    title: 'Paul\'s Mixed PatterFried Mushrooms',
    price: '$12.99',
    tags: 'Your Choice of Any Three: Texas Toothpick, Potato Skins, Chicken Strips, Fried Mushrooms, Boneless Chicken Bite (BBQ or Buffalo), Fried Cheese Curds, Spinach Artichoke Dip, Or Fried Greenbeans',
  },
];

const salads = [
  {
    title: 'Dressings',
    price: '',
    tags: 'Homemade Ranch, Homemade Blue Cheese, Homemade Balsamic Vinaigrette, 1000 Island, Honey Mustard, French, Italian, Oil & Vinegar, Lite  Raspberry Vinaigrette (All Dressings are Served on the Side)',
  },
  {
    title: 'House Caesar',
    price: '$7.99',
    tags: 'Romaine Lettuce, Caesar Dressing, Parmigiano Cheese, and Croutons',
  },
  {
    title: 'House Salad',
    price: '$7.99',
    tags: 'Greenleaf Lettuce, Tomato, Shredded Cheese,  Sliced Red Onions, Croutons, Choice of Dressing',
  },
  {
    title: 'Raspberry Pecan Salad',
    price: '$7.99',
    tags: 'Green Leaf Lettuce , Spiced Pecans, Orange Segments and Raspberry Vinaigrette',
  },
  {
    title: 'Cobb Salad',
    price: '$9.49',
    tags: 'Romaine Lettuce with Onions, Eggs, Bacon, Tomato, Blue Cheese Crumbles, Croutons',
  },
  {
    title: 'Chef Salad',
    price: '$9.49',
    tags: 'Green Leaf Lettuce topped with Ham, Turkey, Bacon, Shredded Cheese, Egg, Tomato and Croutons',
  },
  {
    title: 'Cranberry Chicken Salad',
    price: '$10.49',
    tags: 'Lettuce topped with, Grilled Chicken, Blue Cheese Crumbles, Dried Cranberries, Mandarin Oranges, Sliced Red Onions, and Glazed Pecans severed with a Lite Raspberry Vinaigrette',
  },
  {
    title: 'Southwest Chicken Salad',
    price: '$10.49',
    tags: 'Green Leaf Lettuce , Black Bean and Corn Salsa, Tomatoes, Shredded Cheese and Grilled Chicken',
  },
  {
    title: 'Vegetable Plate',
    price: '$9.99',
    tags: 'Choice of Three of Our Dinner Sides',
  },
];

const grills = [
  {
    title: 'New York Strip--7oz',
    price: '$12.99',
    tags: 'Served with one side; two sides: $14.99',
  },
  {
    title: 'Chopped Steak--6oz',
    price: '$9.49',
    tags: 'With Grilled Onions and Sautéed  Mushrooms, with Mashed Potatoes or French Fries and a Salad',
  },
  {
    title: 'Teriyaki Salmon',
    price: '$11.99',
    tags: 'Served With Teriyaki Sauce, choice of two sides',
  },
  {
    title: 'Grilled Salmon',
    price: '$11.49',
    tags: 'Served with a Dill Cream Sauce or Caper Lemon Sauce, Rice, and a Salad',
  },
  {
    title: 'RARITY',
    price: '',
    tags: 'RARE—Cool, Red Center; MEDIUM RARE—Warm, Red Center; MEDIUM—Hot, Pink Center; MEDIUM WELL—Little pink in Center; WELL—Cooked Throughout, No Guarantee on WELL DONE Steaks',
  },
];

const others = [
  {
    title: 'Shrimp Scampi',
    price: '$11.99',
    tags: 'Five Large Shrimp in a White Wine, Garlic Butter Sauce, served with a Side Salad',
  },
  {
    title: 'Chicken Quesadilla',
    price: '$9.49',
    tags: 'Smoked Chicken, Tomatoes, Green Chilies, and Cheddar-Jack Cheese in a Tortilla grilled to perfection with Chipotle Ranch, Sour Cream, Salsa and a Salad',
  },
  {
    title: 'Fettuccine Alfredo',
    price: '$8.49',
    tags: 'With a Plain or Spicy Alfredo Sauce and Toast Points',
  },
  {
    title: 'Spaghetti Marinara',
    price: '$8.49',
    tags: 'Spaghetti in a Homemade Marinara Sauce served with Meatballs and Toast Points',
  },
  {
    title: 'Chicken Parmigiana',
    price: '$9.49',
    tags: 'Fried Chicken Topped with Homemade Marinara Sauce and Mozzarella Cheese, Served on Spaghetti or Sub Fettuccine Alfredo: $0.99',
  },
  {
    title: 'ADD ON',
    price: '',
    tags: 'Add Grilled or Fried Chicken: $5.49 Add Blackened Chicken: $5.99  Add Shrimp: $6.49',
  },
];

const sandwiches = [
  {
    title: 'All Sandwiches',
    price: '',
    tags: 'Served with Choice of Chips or French Fries (for a Side Salad add: $0.99)',
  },
  {
    title: 'Chicken Parmigiana Sandwich',
    price: '$8.99',
    tags: 'Fried Chicken Topped w/Homemade Marinara Sauce & Mozzarella Cheese served on a Bun',
  },
  {
    title: 'French Dip',
    price: '$9.49',
    tags: 'Thin Sliced Prime Rib on a Hoagie Bun and Swiss Cheese with Au Jus',
  },
  {
    title: 'Crab Cake Pooboy',
    price: '$9.49',
    tags: 'Crab Cakes, Lettuce, Tomato, Red Onion, and Tartar Sauce on a Toasted Bun',
  },
  {
    title: 'Classic Club',
    price: '$8.99',
    tags: 'Turkey and Ham, Bacon, Lettuce Tomato, Cheddar Cheese on Wheat Berry Bread',
  },
  {
    title: 'Build Your Own',
    price: '$8.49',
    tags: 'Chicken Sandwich, Steak Burger, The Impossible Burger (add: $2.50); Grilled Chicken Breast or Fresh Ground Steak Topped with Your Choice of: Sliced Onion, Lettuce, Tomato, Pickle Chips, Mayo, Ketchup, Mustard',
  },
  {
    title: 'Choose Your Premium Toppings',
    price: '',
    tags: 'American Cheese $0.50; Mozzarella $0.50; Blue Cheese $0.50; Sautéed Mushrooms $0.75; Extra 6oz Patty $3.49; BBQ Sauce $0.35; Teriyaki Sauce $0.35; Jalapenos $0.25; Cheddar $0.50; Swiss $0.50; Bacon $1; Grilled Onion $0.75; Sliced Ham $1; Buffalo Sauce $0.35; Pineapple $0.35; Served on a Toasted Bun, with Fresh Cut French Fries',
  },
];

const entrees = [
  {
    title: 'New York Strip—12oz',
    price: '$23.99',
    tags: '',
  },
  {
    title: 'Filet Mignon--6oz',
    price: '$22.49',
    tags: '8oz $25.49',
  },
  {
    title: 'Pork Chop--12oz',
    price: '$14.99',
    tags: 'With a Side of BBQ or Teriyaki Sauce',
  },
  {
    title: 'Chicken Breasts',
    price: '$14.99',
    tags: 'Marinated and Grilled or Breaded and Fried',
  },
  {
    title: 'Southwest Chicken',
    price: '$15.99',
    tags: 'Glazed in Barbeque, Shredded Cheese, Bacon, Diced Tomatoes and Green Onions',
  },
  {
    title: 'Homemade Meat Loaf',
    price: '$10.99',
    tags: 'With Homemade Mashed Potatoes, White or Brown Gravy and Green Beans',
  },
  {
    title: 'BBQ Baby Back Ribs',
    price: '$19.99',
    tags: 'Glazed in BBQ sauce; 1/2 $15.49 Full $19.99',
  },
  {
    title: 'Rib Eye--14oz',
    price: '$26.99',
    tags: '',
  },
  {
    title: 'Sirloin--7oz',
    price: '$17.99',
    tags: '',
  },
  {
    title: 'Chopped Steak--10oz',
    price: '$12.99',
    tags: 'Fresh Ground Steak Topped With Grilled Onions and Sautéed Mushrooms',
  },
  {
    title: 'Chicken Fried Chicken',
    price: '$11.99',
    tags: 'With Homemade Mashed Potatoes, White or Brown Gravy and Green Beans',
  },
  {
    title: 'Chicken Fried Steak',
    price: '$11.99',
    tags: 'With Homemade Mashed Potatoes, White or Brown Gravy and Green Beans',
  },
  {
    title: 'Peppercorn Beef',
    price: '$16.99',
    tags: 'Grilled Medallions of Beef in a Peppercorn Cream Sauce',
  },
  {
    title: 'RARITY',
    price: '',
    tags: 'All Entrées Can Be Baked, Or Grilled; RARE—Cool, Red Center; MEDIUM RARE—Warm, Red Center; MEDIUM—Hot, Pink Center; MEDIUM WELL—Little pink in Center; WELL—Cooked Throughout, No Guarantee on WELL DONE Steaks',
  },
];

const fridaySpecials = [
  {
    title: 'Prime Rib',
    price: '$26.99',
    tags: '8oz--$17.49; 12oz--$23.99; 16oz--$26.99',
  },
  {
    title: 'ADD ON',
    price: '',
    tags: 'Blue Cheese Cream Sauce $4.49; Marsala Mushroom Sauce $4.49; Grilled Onions $3.49; Sautéed Mushrooms $3.49; Grilled Shrimp $6.49; Peppercorn Sauce $4.49; Add Half Slab of Ribs $8.99',
  },
  {
    title: 'SIDES',
    price: '',
    tags: 'Steamed Broccoli; Vegetable Medley (Blend Of Squash, Zucchini and Carrots); Wild Rice Pilaf; Asparagus (1.00 add); Green Beans; Spaghetti Marinara; Dinner Caesar Dinner; Salad Choice of Dressing; Loaded Baked Potato (Butter, Sour Cream, Bacon Bits, Grated Cheddar-Jack Cheese, Green Onions); Fresh Cut French Fries; Mashed Potatoes With White or Brown Gravy; Loaded Baked Sweet Potato (Butter and Brown Sugar); Cup of Soup (Changes Daily); Fettuccini Alfredo',
  },
  {
    title: 'Build Your Own',
    price: '$10.99',
    tags: 'Chicken Sandwich, Steak Burger, The Impossible™ Burger (2.50 add); Topped with Your Choice of: Sliced Red Onion, Lettuce, Tomato, Pickle Chips, Choice of Mayo, Mustard, Ketchup ',
  },
  {
    title: 'Choose Your Premium Toppings',
    price: '',
    tags: 'American Cheese $0.50; Cheddar $0.50; Mozzarella $0.50; Swiss $0.50; Blue Cheese $0.50; Bacon $1.00; Sautéed Mushrooms $0.75; Grilled Onion $0.75; Extra 6oz Patty $3.49; Sliced Ham 1.00; BBQ Sauce $0.35; Buffalo Sauce $0.35; Teriyaki Sauce $0.35; Pineapple $0.25; Jalapenos $0.25',
  },
];

const seafoods = [
  {
    title: 'Grilled Salmon',
    price: '$16.49',
    tags: 'Served with a Dill Cream Sauce or Caper Lemon Sauce',
  },
  {
    title: 'Fried Shrimp',
    price: '$15.49',
    tags: 'Five Large Hand Breaded Shrimp; Served with Lemon and Cocktail Sauce',
  },
  {
    title: 'Grilled Tilapia',
    price: '$15.49',
    tags: 'Served with a Black Bean Salsa',
  },
  {
    title: 'Shrimp Scampi',
    price: '$16.99',
    tags: 'Seven Large Shrimp in a White Wine, Garlic Butter Sauce',
  },
  {
    title: 'Hand Breaded Fried Catfish',
    price: '$12.99',
    tags: 'Hushpuppies and Homemade Tartar Sauce',
  },
  {
    title: '',
    price: '',
    tags: 'Served With Choice of Two Sides',
  },
];

const pastas = [
  {
    title: '',
    price: '',
    tags: 'Served With Side House or Caesar Salad',
  },
  {
    title: 'Fettuccine Alfredo',
    price: '$9.49',
    tags: 'With a Light or Spicy Alfredo Sauce',
  },
  {
    title: 'Spaghetti Marinara',
    price: '$9.49',
    tags: 'Spaghetti in a Homemade Marinara Sauce served with Meatballs',
  },
  {
    title: 'Paul\'s Pasta',
    price: '$10.49',
    tags: 'Fettuccini, Bacon, Garlic, Tomato, Onions, Italian Seasoning, Touch of Cream',
  },
  {
    title: 'Chicken Parmesan',
    price: '$12.49',
    tags: 'Fried Chicken Breast topped with Marinara and a Mozzarella Cheese Served on a Bed of Spaghetti, Or Substitute Bed of Fettuccine Alfredo ($0.99 add )',
  },
  {
    title: 'Manicotti',
    price: '$11.49',
    tags: 'Covered in Homemade Marinara Sauce, Mozzarella Cheese Served with Garlic Bread Stick',
  },
  {
    title: 'ADD ON',
    price: '',
    tags: 'Grilled Chicken or Fried Chicken $5.49; Blackened Chicken $5.99; Grilled Shrimp $6.49',
  },
  {
    title: '',
    price: '',
    tags: 'Blue Zone Project Inspired: Sub Zucchini “Noodles” For Traditional Noodles',
  },
];

const kidMeals = [
  {
    title: '',
    price: '',
    tags: 'Come with French Fries (except Pastas which are served with a small salad)',
  },
  {
    title: 'Steak--4oz',
    price: '$8.99',
    tags: '',
  },
  {
    title: 'Chicken Strips',
    price: '$6.99',
    tags: '',
  },
  {
    title: 'Fried Shrimp',
    price: '$8.49',
    tags: '',
  },
  {
    title: 'Kids Hamburger',
    price: '$6.99',
    tags: 'Add Cheese $0.50',
  },
  {
    title: 'Fettuccini Alfredo',
    price: '$6.99',
    tags: '',
  },
  {
    title: 'Kids Spaghetti',
    price: '$6.99',
    tags: '',
  },
  {
    title: '',
    price: '',
    tags: 'Blue Zone Project Inspired: Sub Zucchini “Noodles”for Traditional Noodles; Baked Potato or Baked Sweet Potato may be substituted for $0.99 ',
  },
];

const beverages = [
  {
    title: '',
    price: '$2.39',
    tags: 'Coffee, Hot Tea, Ice Tea (un-sweet and sweet), Soda (Coke Products)',
  },
];

const warnings = [
  {
    title: '',
    price: '',
    tags: 'The consuming of raw or under cooked meats, poultry, seafood, shellfish or eggs may increase your risk of food borne illness, especially if you have a medical condition. All weights are measured before cooking. Prices Subject to Change without notice',
  },
];

const specials = [
  {
    title: 'Vegetarian "Meat" Pizza',
    price: '$8.99',
    tags: 'Cauliflower Crust Topped with Homemade Marinara, Mozzarella Cheese, Red Onion Served With a Side Salad (Toppings can be added at an additional cost)',
  },
  {
    title: 'The Impossible™ Burger',
    price: '$9.99',
    tags: 'The Impossible™ Burger is a delicious, meaty burger made from plants for people who love meat. Without compromises. Served on a Toasted Bun or Bed of Lettuce Topped with Lettuce and Tomatoes. With a Side of French Fries',
  },
  {
    title: 'Build Your Own',
    price: '$8.49',
    tags: 'Chicken Sandwich or Steak Burger; Served on a Toasted Bun with Fresh Cut French Fries, Topped with Choice of Lettuce, Sliced Tomato, Red Onion, Sliced Pickles',
  },
  {
    title: 'Choose Your Premium Toppings',
    price: '',
    tags: 'American Cheese $0.50; Mozzarella $0.50; Blue Cheese $0.50; Sautéed Mushrooms $0.75; Extra 6oz Patty $3.49; BBQ Sauce $0.35; Teriyaki Sauce $0.35; Jalapenos $0.25; Cheddar $0.50; Swiss $0.50; Bacon $1; Grilled Onion $0.75; Sliced Ham $1; Buffalo Sauce $0.35; Pineapple $0.35; Served on a Toasted Bun, with Fresh Cut French Fries',
  },
  {
    title: 'Homemade Meatloaf',
    price: '$8.49',
    tags: 'Homemade Meatloaf, Served with Green Beans and Homemade Mashed Potatoes and Choice of Gravy',
  },
  {
    title: 'Black Bean Quesadilla',
    price: '$8.49',
    tags: 'Black Bean & Corn Salsa, Tomatoes, Green Chilies, and Shredded Cheddar-Jack Cheese in a Tortilla grilled to perfection and served with a side of Salsa, Sour Cream, Chipotle Ranch and a Side Salad',
  },
  {
    title: 'Fried Catfish',
    price: '$7.49',
    tags: 'With French Fries and Hushpuppies',
  },
  {
    title: 'Baked Potato and a Side Salad',
    price: '$7.49',
    tags: '',
  },
  {
    title: 'Chicken Fried Steak',
    price: '$7.89',
    tags: 'With Mashed Potatoes and Green Beans',
  },
  {
    title: 'Grilled Chicken Breast and Pineapple',
    price: '$7.89',
    tags: 'Served with a Salad',
  },
  {
    title: 'Chicken Fried Chicken or Steak Sandwich',
    price: '$7.89',
    tags: 'With French Fries  (Served with Lettuce, Tomato, Mayo',
  },
  {
    title: 'Chicken Fried Chicken',
    price: '$8.49',
    tags: 'With Mashed Potatoes and Green Beans',
  },
  {
    title: 'Teriyaki Chicken Breast and Pineapple Served',
    price: '$8.49',
    tags: 'On a Bed of Rice with a Side Salad',
  },
  {
    title: 'Cranberry Chicken Salad',
    price: '$8.49',
    tags: 'Lettuce topped with, Grilled Chicken, Blue Cheese Crumbles, Dried Cranberries, Mandarin Oranges, Sliced Red Onions, and Glazed  Pecans severed with a Lite Raspberry Vinaigrette',
  },
  {
    title: 'Manicotti',
    price: '$8.49',
    tags: 'Covered in Homemade Marinara Sauce, Mozzarella Cheese Served with Garlic Bread and a Salad',
  },
  {
    title: '',
    price: '',
    tags: 'Substitutions may-be an additional charge',
  },
];

// eslint-disable-next-line
export default { appetizers, salads, grills, others, sandwiches, entrees, fridaySpecials, seafoods, pastas, kidMeals, beverages, warnings, specials};
